<template>
  <div class="download bg-white">
    <headerCom></headerCom>
    <div class="down-content">
      <el-tag v-if="this.$route.query.uid && hasUseQuery" closable @close="closeParams">UID:{{this.$route.query.uid}}</el-tag>
      <el-table border
                :data="tableData" ref="multipleTable"
                highlight-current-row
                header-row-class-name="header-row-class-name"
                style="width: 100%"
                empty-text="请选择搜索条件"
                :height="tableHeight">
        <!--
        <el-table-column
                type="selection" align="center"
                width="55">
        </el-table-column>
        -->
        <el-table-column fixed align="center"
                prop="id" width="70"
                label="ID">
          <template slot="header" slot-scope="scope">
            <el-input class="padding-0"
                    v-model="query.activityId"
                    size="mini" @change="keywordSearch"
                    placeholder="ID"/>
          </template>
        </el-table-column>
        <el-table-column
                prop="activityName"
                label="活动名称">
          <template slot="header" slot-scope="scope">
            <div class="flex">
              <el-select v-model="query.vipType" @change="keywordSearch"
                         size="mini" placeholder="版本" class="padding-0"
                         style="width: 60px;">
                <el-option label="全部版本" value=""></el-option>
                <template v-for="(item,vipType) in VERSIONS">
                  <el-option :label="item.versionName" :value="vipType"></el-option>
                </template>
              </el-select>
              <el-input
                      v-model="query.keyword"
                      size="mini" @change="keywordSearch"
                      placeholder="活动名称"/>
            </div>
          </template>
          <template slot-scope="scope">
            <a :href="'https://pfotoo.com/#/activity/'+(scope.row.aesId||'缺少参数')"
               :title="VERSIONS[scope.row.vipType].versionName"
               target="_blank">
              <img :src="'https://assets.pfotoo.com/images/version/'+scope.row.vipType+'.png'" style="width: 12px;height: 12px;"/>
              {{scope.row.activityName}}
            </a>
          </template>
        </el-table-column>
        <el-table-column align="center"
                label="活动类型"
                prop="activityType"
                width="80">
        </el-table-column>
        <el-table-column
                prop="activityName" width="80"
                label="业务类型">
          <template slot="header" slot-scope="scope">
            <el-select v-model="query.useType" @change="keywordSearch"
                       size="mini" placeholder="业务类型"
                       style="width: 100px;">
              <el-option v-for="(item,index) in useTypes" v-bind:key="item"
                         :label="item" :value="index"></el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
              {{useTypes[scope.row.useType]}}
          </template>
        </el-table-column>
        <el-table-column width="100"
                prop="gmtCreated"
                label="创建时间">
          <template slot="header" slot-scope="scope">
            <el-date-picker class="pfotoo-el-date-picker"
                    v-model="datePicker" :editable="false"
                    type="daterange" @change="keywordSearch"
                    align="left" size="mini"
                    unlink-panels value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="创建时间"
                    end-placeholder="点击选择"
                    :picker-options="pickerOptions">
            </el-date-picker>
          </template>
          <template slot-scope="scope">
            {{unixtoTime(scope.row.gmtCreated,'YYYY/MM/DD')}}
          </template>
        </el-table-column>
        <el-table-column width="100"
                prop="creatorName"
                label="活动创建人">
          <template slot-scope="scope">
            <router-link :to="'/operate/members?uid='+scope.row.creatorId">{{scope.row.creatorName}}</router-link>
          </template>
        </el-table-column>
        <el-table-column width="120"
                         prop="creatorName"
                         label="创建人电话">
          <template slot-scope="scope">
            <router-link :to="'/operate/members?uid='+scope.row.creatorId">
              {{(scope.row.mobile||'').replace(/(.*)([\d]{4})([\d]{4})/,
              function($0,$1,$2,$3){return $1+'-'+$2+'-'+$3})}}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column width="100"
                         prop="sponsor"
                         label="发起人">
          <template slot-scope="scope">
            {{scope.row.sponsor}}
          </template>
        </el-table-column>
        <el-table-column width="140"
                prop="mobile"
                label="活动时间">
          <template slot-scope="scope">
            <template v-if="scope.row.isLongTerm==1">
              长期征集
            </template>
            <template>
              {{unixtoTime(scope.row.startTime,'YYYY/MM/DD HH:II')}}~{{unixtoTime(scope.row.endTime,'YYYY/MM/DD HH:II')}}
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center"
                          label="活动介绍">
          <template slot-scope="scope">
            <el-popover
                    placement="top-start"
                    title=""
                    width="200"
                    trigger="hover"
                    :content="(scope.row.description||'').replace(/<[^>]+>/g,'')">
              <div class="font-more-three" slot="reference">{{(scope.row.description||'').replace(/<[^>]+>/g,'')}}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
                fixed="right"  align="center"
                label="操作"
                width="60">
          <template slot-scope="scope">
              <span class="el-dropdown-link" @click="activitySetting(scope.row)">
                  <i class="el-icon-setting"></i>
                </span>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <div class="members-page" v-if="total>pageSize">
      <el-pagination background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageIndex"
              :page-sizes="[20, 30, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
      </el-pagination>
    </div>
    <activitySetting ref="activitySetting"></activitySetting>
  </div>
</template>

<script>
  import headerCom from '../components/header.vue'
  import App from '../util/comfun'
  import activitySetting from './components/activitySetting.vue'
  export default {
    //name: 'activitys',
    data () {
      return {
        minHeight:window.innerHeight-82,
        tableHeight:window.innerHeight-150,
        tableData: [],
        pageIndex:1,
        pageSize:20,
        unixtoTime:App.unixtoTime,
        keyword:'',
        query:{
          activityId:'',
          keyword:''
        },
        total:0,
        datePicker:['',''],
        //征集征稿、收集文件、大众投票、评委评选、活动比赛、自定义
        useTypes:['自定义','征集征稿','收集文件','大众投票','评委评选','活动比赛'],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '清除日期',
            onClick(picker) {
              picker.$emit('pick', ['','']);
            }
          }]
        },
        hasUseQuery:true,
        VERSIONS:{},
      }
    },
    components:{
      headerCom,
      activitySetting,
    },
    methods:{
      handleSizeChange(pageSize){
        this.pageSize=pageSize
        this.getnewlist()
      },
      handleCurrentChange(pageIndex){
        this.pageIndex=pageIndex
        this.getnewlist()
      },
      getnewlist(){
        let params = {
          "pageIndex": this.pageIndex,
          "pageSize": this.pageSize,
          ...this.query
        }
        if(this.datePicker[0]){
          params.startTime=this.datePicker[0]+' 00:00:00'
          params.endTime=this.datePicker[1]+' 23:59:59'
        }
        if(this.hasUseQuery){
          if(this.$route.query.uid){
            params.userId=this.$route.query.uid
          }
        }
        this.params=params
        let loading=this.$loading({text:'loading...',target: '.content',})
        App.demand('/admin/activity/queryActivityList','POST',params).then(json=>{
          setTimeout(()=>{loading.close();},0)
          if(json.code==200) {
            this.tableData = json.data.activityList||[];
            this.total=json.data.activityTotal;
            if(this.total<1){
              this.$message({
                showClose: true,
                message: "暂无数据"
              });
            }
          }else{
            this.imgCount=0
            this.worksCount=0
            this.browse=0
            this.likenum=0
            this.commentCount=0
            this.tableData=[];
            this.allselect=false;
            this.total=0;
            this.$message({
              showClose: true,
              message: json.message
            });
          }
        })
      },
      keywordSearch(e){
        this.pageIndex=1
        this.getnewlist();
      },
      activitySetting(activity){
        this.$refs.activitySetting.show(activity)
      },
      closeParams(){
        this.hasUseQuery=false
      },
    },
    mounted(){
      Object.keys(this.$route.query).length>0?this.getnewlist():''
      setTimeout(()=>{
        this.VERSIONS=wxlite.VERSIONS
      },800)
    },

  }
</script>

<style>
  .down-content{
    widdiv: 100%;
    position: relative;
    padding:0;
  }
  .table-header{
    background: #FAFAFA;
  }
  .tr{
    height: 40px;
    line-height: 1.4;
    overflow: hidden;
  }
  .td{
    width: 60px;
    min-height: 40px;
    text-align: center;
    padding:10px 5px;
    box-sizing: border-box;
    border-right: 1px solid #E0E0E0;
  }
  .bg-light-gray{
    background: #EEF2F2;
  }
  .table-total{
    width:100%;
    height: 50px;
    padding:0 10px;
    box-sizing: border-box;
  }
  .draft-total-data>div{
    margin-left: 20px;
    color: #999;
  }
  .draft-total-data>div:first-child{
    margin-left: 10px;
  }
  .draft-total-data .font-size14{
    color: #353535;
  }
  .down-content{
    width: 100%;
    padding-left:15px;
    box-sizing: border-box;
  }
  /* .draft-title{
    height: 50px;
    line-height: 50px;
    margin-right: 10px;
  } */
  .table{
    width: 100%;
    border-top: 1px solid #E0E0E0;
    box-sizing: border-box;
    min-height: 540px;
    border-collapse: collapse;
  }
  .td:first-child{
    border-left: 1px solid #E0E0E0;
  }
  .checkbox {
    width: 16px;
    height: 16px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    cursor: pointer;
    display: inline-block;
  }
  .members-page{
    padding: 10px 0 10px 10px ;
  }
  .work-img{
    width:20px;
    height:20px;
    display: inline-block;
  }
  .td a{

  }
  .td a:hover{
    color: #27C4A2;
  }
  .pdf-mask{
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    z-index:9999;
    background: rgba(0,0,0,.8);
  }
  .pdf-cover{
    width: 800px;
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    margin: 0 auto;
    z-index:10000;
    overflow: scroll;
    box-sizing: border-box;
  }
  .detail-unit-list {
      padding-top: 18px;
  }
  .detail-unit-single {
      margin-right: 30px;
      margin-bottom: 10px;
      line-height: 20px;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 500;
  }
  .unit-green-font {
      border-bottom: 1px solid #3dc4a7;
  }
  .el-icon-arrow-up:before {
      content: "\E6E1";
      position: relative;
      top: -6px;
  }
  .down-content .el-input__inner{
      height: 30px!important;
      line-height: 30px!important;
  }
  .el-date-editor--datetimerange.el-input__inner {
      width: 356px;
  }
  .el-date-editor .el-icon-time{
    line-height: 22px;
  }
  .el-date-editor .el-range-separator{
    line-height: 22px;
  }
  .search{
    height: 36px;
    border-radius: 5px;
    background: #F2F2F3;
    margin-right: 20px;
  }
  .search-input{
      width: 100px;
      height: 100%;
      outline: none;
      transition: width ease .3s;
      background: transparent;
      padding: 0 5px;
      border: 0;
      box-sizing: border-box;
      line-height: 36px;
      font-size: 14px;
      margin-right: 5px;
  }
    .search-button{
    padding: 0 10px;
    height: 100%;
  }
  .search-button img{
    width: 15px;
    height: 16px;
  }
  .header-row-class-name .cell{
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Light;
    font-weight: 300;
    color: #999999;
    line-height: 17px;
  }
  .pfotoo-el-date-picker.el-date-editor--daterange.el-input__inner {
    width: 79px;
    flex-direction:column;
    padding: 0;
  }
  .pfotoo-el-date-picker.el-date-editor .el-range__icon{
    display: none;
  }
  .pfotoo-el-date-picker.el-date-editor .el-range-separator{
    display: none;
  }
  .pfotoo-el-date-picker.el-range-editor .el-range-input{
    width: 99%;
  }
  .padding-0 .el-input__inner{
    padding: 0;
    text-align: center;
  }
  .el-select--mini .el-icon-arrow-up:before{
    top:auto;
    right: calc(100% - 15px);
  }
</style>


// WEBPACK FOOTER //
// src/pages/activitys.vue